import { message } from "antd";
import { client } from "../../../actions";
import uri from "../constants/uri";

const recoverPassword = async ({
	newPassword,
	confirmPassword,
	login,
	code,
	onExit,
}) => {
	try {
		const response = await client.post(
			`${uri}/recover_password`,
			{ newPassword, confirmPassword, login, code },
			{}
		);
		if (response.data.result === "Error") {
			message.error(response.data.message);
		} else {
			message.success("Пароль изменён");
			onExit();
		}
	} catch (error) {
		console.error(error);
		message.error("Произошла ошибка");
	}
};

export default recoverPassword;
